<template>
  <div class="footer">
    <van-collapse v-model="activeNames"
                  accordion>
      <van-collapse-item name="1"
                         title="About ENN">
        <div class="footersubmenu">
          <a @click="goToPage('En_about','#jtjj')">Group Overview</a>
          <a @click="goToPage('En_about','#qywh')">Corporate Culture</a>
          <a @click="goToPage('En_about','#shzz')">Social Responsibility</a>
          <a @click="goToPage('En_about','#fzlc')">Development History</a>
          <a @click="goToPage('En_about','#ldtd')">Leadership Team</a>
          <a @click="goToPage('En_about','#gpxx')">Stock Information</a>
        </div>
      </van-collapse-item>
      <van-collapse-item name="2"
                         title="Business Layout">
        <div class="footersubmenu">
          <a @click="goToPage('En_energy')">Clean Energy Business</a>
          <a @click="goToPage('En_life')">Quality Life Business</a>
          <a @click="goToPage('En_intelligent')">Industrial Intelligence Business</a>
        </div>
      </van-collapse-item>
    </van-collapse>
    <a @click="goToPage('En_innovate')"
       class="footermenu">Innovation Capability</a>
    <a @click="goToPage('En_talent')"
       class="footermenu">Talent Career</a>
    <a @click="goToPage('En_news')"
       class="footermenu">ENN News</a>
    <a @click="goToPage('En_contactus')"
       class="footermenu">Contact Us</a>
    <a @click="goToPage('En_legal')"
       class="footermenu">Legal Notice</a>
    <!-- 底部信息 -->
    <div class="footerinfo">
      Copyrights © 2025 ENN Group<br />
      <a href="https://beian.miit.gov.cn"
         target="_blank">冀ICP备05013989号-8</a>
      <a href="https://beian.mps.gov.cn/#/query/webSearch?code=13109802000309"
         target="_blank"><img src="https://beian.mps.gov.cn/img/logo01.dd7ff50e.png"
             alt="">冀公网安备13109802000309</a>
    </div>
    <!-- 底部信息 -->
  </div>
</template>

<script>
export default {
  name: "Footer",
  data () {
    return {
      activeNames: "0",
    };
  },
  methods: {
    goToPage (url, maodian) {
      console.log(window.location.hash)
      console.log(url)
      let nowUrl = window.location.hash.replace('#/', '')
      if (nowUrl !== url) {
        this.$router.push({ name: url, params: { maodian: maodian } })
      } else {
        this.popmenu = false
        this.pop_about = false
        this.pop_busi = false
        const targetElement = document.querySelector(maodian);
        window.scrollTo({ top: targetElement.offsetTop - 45, behavior: 'smooth' });
      }
    },
  },
  mounted () {
  }
};
</script>
<style>
.footer {
  width: 630px;
  height: auto;
  overflow: hidden;
  padding: 60px;
  background: #f1f2f6;
}
.footer .footermenu {
  width: 630px;
  height: 80px;
  display: block;
  float: left;
  text-align: left;
  font-size: 28px;
  color: #000;
  line-height: 80px;
}
.footerinfo {
  border-top: 1px solid #cbcbcb;
  width: 630px;
  height: auto;
  overflow: hidden;
  background: #f1f2f6;
  font-size: 24px;
  line-height: 50px;
  color: #868686;
  padding-top: 50px;
}
.footerinfo img {
  width: 26px;
  height: 26px;
}
.footerinfo a {
  color: #323233;
  padding: 0 10px;
}
.footer .footersubmenu {
  width: 630px;
  height: auto;
  display: block;
  float: left;
}
.footer .footersubmenu a {
  width: 595px;
  height: 80px;
  display: block;
  float: left;
  color: #323233;
  font-size: 26px;
  line-height: 80px;
  text-align: left;
  padding-left: 35px;
}
/* 底部折叠组件 */
.van-collapse-item {
  width: 630px;
  float: left;
  height: auto;
  overflow: hidden;
}
.van-collapse {
  height: auto;
  overflow: hidden;
  float: left;
}
.van-cell {
  width: 630px;
  height: 80px;
  line-height: 80px;
  background-color: #f1f2f6;
  font-size: 28px;
  padding: 0;
  text-align: left;
  color: #000;
}
.van-collapse-item__content {
  padding: 0;
  height: auto;
  overflow: hidden;
  background: #f1f2f6;
}
</style>